// Property type factories used to build appearance editors
import {
  StrokeType,
  FontType,
  BooleanType,
  RiskLevelsType,
} from "../PropertyTypes";
import { RG_DEFAULT_LEVELS } from "../../chartLib/lib/interactive/calculoRGMath";

// Risco (Risk management) category — ferramentas de gestão de operação.
// Primeira moradora: Cálculo R/G, migrada do Silverlight (CalculoRGObject,
// "Cálculo R/G" no menu legado). Ver board projects/1.
const riscoRegistry = {
  displayName: "Risco",
  interactives: {
    calculoRG: {
      displayName: "Cálculo R/G",
      key: "calculoRG",
      icon: "Tirone_Levels",
      propName: "calculosRG",
      component: "CalculoRG",
      defaultOptionsForAppearance: [
        // Pen base do objeto (legado: DefaultDrawColor branco); linhas sem cor
        // própria herdam esta
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FFFFFF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        // Split do legado: -1=stop (vermelho #C00000), 0=entrada, 3/4/5=alvos
        RiskLevelsType({
          name: "levels",
          displayName: "Linhas",
          defaultValue: RG_DEFAULT_LEVELS,
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            fontSize: 10,
            color: "#FFFFFF",
          },
        }),
        // Legado: TextBrush null ⇒ rótulo desenhado com a pen da própria linha
        BooleanType({
          name: "labelUsaCorDaLinha",
          displayName: "Rótulo na cor da linha",
          defaultValue: true,
        }),
      ],
    },
  },
};

export default riscoRegistry;
